import { ItemUnit } from '@dreryk/egabinet-invoice-frontend-api';

import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { InvoiceItemsTableBean } from './InvoiceItemsTable.types';
import { medicalServiceRowVisitor, NEW_ROW_EMPTY_VALUE_PLACEHOLDER } from './InvoiceItemsTable.utils';
import { InvoiceItemsTableUnitSelectCell } from './InvoiceItemsTableUnitSelectCell';

type InvoiceItemsTableUnitCellProps = InteractiveTableCellProps<ItemUnit>;

export const InvoiceItemsTableUnitCell = (props: InvoiceItemsTableUnitCellProps): JSX.Element => {
   const { defaultValue, index, name, testId } = props;
   const { getCellValue } = useInteractiveTableContext<InvoiceItemsTableBean>();
   const invoiceParameters = getCellValue('invoiceParameters', index);
   const unit = getCellValue('unit', index);

   return medicalServiceRowVisitor({
      nameEditable: invoiceParameters.nameEditable,
      rowAddedManually: invoiceParameters.rowAddedManually,
   })({
      visitFetchedRow: () => (
         <InvoiceItemsTableUnitSelectCell defaultValue={defaultValue} index={index} name={name} testId={testId} />
      ),
      visitManuallyAddedRow: () => (
         <InteractiveTable.CustomCell defaultValue={defaultValue} index={index} name={name} testId={testId}>
            {() => <>{NEW_ROW_EMPTY_VALUE_PLACEHOLDER}</>}
         </InteractiveTable.CustomCell>
      ),
      visitManuallyAddedRowWithName: () => (
         <InvoiceItemsTableUnitSelectCell defaultValue={unit} index={index} name={name} testId={testId} />
      ),
   });
};
